var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.header_show)?_c('pageHeader'):_vm._e(),(_vm.isRouterAlive)?_c('router-view',{staticClass:"app-page",on:{"header":_vm.header,"footer":_vm.footer}}):_vm._e(),(_vm.footer_show)?_c('pageBottom'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }